import {
  BASE_SCORE_PER_PIECE,
  DIFFICULTY_CONFIG,
  HINT_PENALTY,
  MISTAKE_PENALTY,
  type GameSession,
  type ScoreResult,
} from "./types.ts";

function starsFor(percentage: number): 0 | 1 | 2 | 3 {
  if (percentage >= 90) return 3;
  if (percentage >= 70) return 2;
  if (percentage >= 40) return 1;
  return 0;
}

/** 依 SRS §7.2 計分。用時取整秒，與 HUD 顯示一致，避免結算分數和畫面對不起來。 */
export function calculateScore(session: GameSession, elapsedSeconds = session.elapsedSeconds): ScoreResult {
  const seconds = Math.floor(elapsedSeconds);
  const baseScore = session.pieces.length * BASE_SCORE_PER_PIECE;
  const penalty =
    seconds * DIFFICULTY_CONFIG[session.difficulty].timePenaltyPerSecond +
    session.mistakeCount * MISTAKE_PENALTY +
    session.hintUsedCount * HINT_PENALTY;

  const finalScore = Math.max(0, Math.round(baseScore - penalty));
  const percentage = Math.round((finalScore / baseScore) * 1000) / 10;

  return {
    baseScore,
    penalty: Math.round(penalty),
    finalScore,
    percentage,
    stars: starsFor(percentage),
    elapsedSeconds: seconds,
    mistakeCount: session.mistakeCount,
    hintUsedCount: session.hintUsedCount,
  };
}
